import React from 'react';

import Chip from 'components/Chip';
import { colors } from 'theme/colors';

import { ChoiceTone } from '../choiceTone';
import { ChipGroup } from './styles';

export type ChoiceAnswerChipEntry = {
  label: string;
  tone?: ChoiceTone;
};

export type ChoiceAnswerChipsProps = {
  entries: ChoiceAnswerChipEntry[];
  id?: string;
};

const COLOURLESS = { background: colors.grey[100], border: colors.grey[300] };

const ChoiceAnswerChips: React.FunctionComponent<ChoiceAnswerChipsProps> = ({ entries, id }) => (
  <ChipGroup id={id}>
    {/* Keyed by position: two options may legitimately share a label. */}
    {entries.map(({ label, tone }, index) => (
      <Chip
        key={`${label}-${index}`}
        label={label}
        variant="outlined"
        capitalizeLabel={false}
        // Dark label on purpose: coloured text on the tint measured 2.5-4.0:1, under the 4.5:1 floor.
        colors={{
          background: (tone ?? COLOURLESS).background,
          border: (tone ?? COLOURLESS).border,
          foreground: colors.text.primary,
        }}
        data-testid="audit-choice-answer-chip"
      />
    ))}
  </ChipGroup>
);

export default ChoiceAnswerChips;
